module.exports = __webpack_public_path__ + "img/08.fc7354f4.jpg";